import React from "react";
import "./CtaBottom.css"
import iconWa from "../../assets/cta_bottom/icon_WA.webp";
import modelCta from "../../assets/cta_bottom/model_CTA_akhir.webp"

const CtaBottom = () => {
  return (
    <React.Fragment>
      <div className="container-cta-bottom">
        <div className="box-cta-bottom">
          <div className="text-cta-bottom">
            <h1 className="title-cta-bottom">Gabung Sekarang</h1>
            <button className="btn-cta-bottom">Sebelum Kehabisan Kursi</button>
            <div className="parent-no-wa">
              <img src={iconWa} alt="Bimbel Sekolah Kedinasan" className="icon-wa-cta-bottom" />
              <h2 className="text-no-wa">Kak Nia <br /> 0821-7414-4728</h2>
            </div>
            <div className="parent-no-wa">
              <img src={iconWa} alt="Bimbel Sekolah Kedinasan" className="icon-wa-cta-bottom" />
              <h2 className="text-no-wa">Kak Dila <br /> 0856-0042-2188</h2>
            </div>
          </div>
          <img src={modelCta} alt="Bimbel Sekolah Kedinasan" className="model-cta-bottom" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CtaBottom;
